import { useEffect, useRef } from "react";

const IMAGES = [
  "https://www.assocham.org/assets/images/1665989777-fintech-banner.jpg",
  "https://www.assocham.org/assets/images/1754628465-Footer%20Banner_HarGhar%20Tiranga.jpg",
  "https://www.assocham.org/assets/images/1687508823-440X159-2.jpg",
  "https://www.assocham.org/assets/images/1687508816-440x159%20(2).jpg",
//   "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=1200",
];

export default function Updates() {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;

    const pause = () => {
      slider.style.animationPlayState = "paused";
    };

    const play = () => {
      slider.style.animationPlayState = "running";
    };

    slider.addEventListener("mouseenter", pause);
    slider.addEventListener("mouseleave", play);

    return () => {
      slider.removeEventListener("mouseenter", pause);
      slider.removeEventListener("mouseleave", play);
    };
  }, []);

  return (
    <section className="relative overflow-hidden py-[7px] bg-[#fffff] mt-7 mb-7 ">
    {/* <section className="relative overflow-hidden py-[7px] bg-[#DA2128] border-t-4 border-[#fdb913]"> */}

        <div className="container-updates mx-auto relative w-[98%]">
      {/* Soft BG Glow */}
      <div className="absolute top-[-200px] left-[-100px] w-[320px] h-[320px] bg-[#cf121c]/10 blur-[120px] rounded-full" />

      <div className="absolute bottom-[-200px] right-[-100px] w-[320px] h-[320px] bg-[#e86e25]/10 blur-[120px] rounded-full" />

      <div className="relative z-10">
        {/* Slider */}
        <div className="w-full overflow-hidden">
          <div
            ref={sliderRef}
            className="flex gap-8 w-max animate-marquee items-center"
          >
            {[...IMAGES, ...IMAGES, ...IMAGES].map((img, index) => (
              <div
                key={index}
                className="
                  relative
                  group
                  flex-shrink-0
                  w-[350px]
                  overflow-hidden
                  rounded-[28px]
                  bg-white
                  border
                  border-gray-200
                  shadow-[0_10px_35px_rgba(0,0,0,0.08)]
                  hover:-translate-y-2
                  transition-all
                  duration-500
                "
              >
                {/* Image */}
                <div
                  className="animate-float"
                  style={{
                    animationDelay: `${index * 0.2}s`,
                  }}
                >
                  <img
                    src={img}
                    alt=""
                    className="
                      w-full
                      h-auto
                      object-contain
                      group-hover:scale-105
                      transition-all
                      duration-700
                    "
                  />
                </div>

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

                {/* Content */}
                {/* <div className="absolute bottom-5 left-5 z-10">
                  <p className="text-white text-xl font-semibold">
                    Featured Update
                  </p>

                  <div
                    className="w-20 h-[4px] rounded-full mt-2"
                    style={{
                      background:
                        "linear-gradient(90deg, #cf121c 0%, #e86e25 100%)",
                    }}
                  />
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>

      {/* Animations */}
      <style jsx>{`
        .animate-marquee {
          animation: marquee 65s linear infinite;
        }

        @keyframes marquee {
          0% {
            transform: translateX(0);
          }

          100% {
            transform: translateX(-33.33%);
          }
        }

        .animate-float {
          animation: float 5s ease-in-out infinite;
        }

        @keyframes float {
          0% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-8px);
          }

          100% {
            transform: translateY(0px);
          }
        }
      `}</style>
    </section>
  );
}